

import objectAssign from 'object-assign'
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import vuexI18n from 'vuex-i18n'
import global_ from './components/until/Global'
import 'font-awesome/css/font-awesome.min.css'
import 'babel-polyfill'
import Es6Promise from 'es6-promise'

Vue.prototype.GLOBAL = global_
Vue.config.productionTip = false
Vue.use(Vuex)

require('es6-promise').polyfill()
Es6Promise.polyfill()

/** i18n **/
let store = new Vuex.Store({
modules: {
i18n: vuexI18n.store
}
})

Vue.use(vuexI18n.plugin, store)

const vuxLocales = require('json-loader!yaml-loader!./locales/all.yml')

/*
const finalLocales = {
'en': objectAssign(vuxLocales['en'], componentsLocales['en']),
'zh-CN': objectAssign(vuxLocales['zh-CN'], componentsLocales['zh-CN'])
}

for (let i in finalLocales) {
Vue.i18n.add(i, finalLocales[i])
}
*/
import DevicePlugin from 'vux/src/plugins/device/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LocalePlugin from 'vux/src/plugins/locale/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import Loading from 'vux/src/components/loading/index.vue'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'


import AjaxPlugin from 'vux/src/plugins/ajax/index.js'

Vue.use(AjaxPlugin)

Vue.use(LocalePlugin)
const nowLocale = Vue.locale.get()
if (/zh/.test(nowLocale)) {
Vue.i18n.set('zh-CN')
} else {
Vue.i18n.set('en')
}

store.registerModule('vux', {
state: {
demoScrollTop: 0,
isLoading: false,
direction: 'forward',
userInfo: null,
classInfo: null,
settingInfo: null,
configInfo: null
},
getters: {
getUserInfo: function (state) {
if (!state.userInfo) {
if (sessionStorage.getItem('userInfo') != 'undefined') {
state.userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
} else {
state.userInfo = undefined;
}
}
return state.userInfo;
},
getClassInfo: function (state) {
if (!state.classInfo) {
if (sessionStorage.getItem('classInfo') != 'undefined') {
state.classInfo = JSON.parse(sessionStorage.getItem('classInfo'));
} else {
state.classInfo = undefined;
}

}
return state.classInfo;
},
getSettingInfo: function (state) {
if (!state.settingInfo) {
if (sessionStorage.getItem('settingInfo') != 'undefined') {
state.settingInfo = JSON.parse(sessionStorage.getItem('settingInfo'));
} else {
state.settingInfo = undefined;
}

}
return state.settingInfo;
},
getConfigInfo: function (state) {
if (!state.configInfo) {
if (sessionStorage.getItem('configInfo') != 'undefined') {
state.configInfo = JSON.parse(sessionStorage.getItem('configInfo'));
} else {
state.configInfo = undefined;
}

}
return state.configInfo;
}
},
mutations: {
updateDemoPosition(state, payload) {
state.demoScrollTop = payload.top
},
updateLoadingStatus(state, payload) {
state.isLoading = payload.isLoading
},
updateDirection(state, payload) {
state.direction = payload.direction
},
$_setUserInfo(state, value) {
state.userInfo = value;
sessionStorage.setItem('userInfo', JSON.stringify(value));
},
$_removeUserInfo(state, value) {
state.userInfo = null;
sessionStorage.removeItem('userInfo');
},
$_setClassInfo(state, value) {
state.classInfo = value;
sessionStorage.setItem('classInfo', JSON.stringify(value));
},
$_removeClassInfo(state, value) {
state.classInfo = null;
sessionStorage.removeItem('classInfo');
},
$_setSettingInfo(state, value) {
state.settingInfo = value;
sessionStorage.setItem('settingInfo', JSON.stringify(value));
},
$_removeSettingInfo(state, value) {
state.settingInfo = null;
sessionStorage.removeItem('settingInfo');
},
$_setConfigInfo(state, value) {
state.configInfo = value;
sessionStorage.setItem('configInfo', JSON.stringify(value));
},
$_removeConfigInfo(state, value) {
state.configInfo = null;
sessionStorage.removeItem('configInfo');
}
},
actions: {
updateDemoPosition({ commit }, top) {
commit({ type: 'updateDemoPosition', top: top })
}
}
})

Vue.use(AlertPlugin)
Vue.use(ToastPlugin)
Vue.use(DevicePlugin)
Vue.use(ConfirmPlugin)
Vue.use(LoadingPlugin)
Vue.use(WechatPlugin)

/* eslint-disable no-new */
new Vue({
el: '#app',
store,
router,
components: { App },
template: '<App/>'
})

Vue.component('loading', Loading)

router.beforeEach((to, from, next) => {
var userInfo = store.getters.getUserInfo;
if ((to.meta.requireAuth == undefined || to.meta.requireAuth) && userInfo == undefined) {
next({
path: '/'
});
} else {
next();
}
})

router.afterEach((to, from) => {
})


// WEBPACK FOOTER //
// ./src/main.js